import { render, staticRenderFns } from "./BtnGroup.vue?vue&type=template&id=0dc748df&scoped=true"
import script from "./BtnGroup.vue?vue&type=script&lang=js"
export * from "./BtnGroup.vue?vue&type=script&lang=js"
import style0 from "./BtnGroup.vue?vue&type=style&index=0&id=0dc748df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc748df",
  null
  
)

export default component.exports